<template>
    <div>
      <div style="text-align: center">
        <h3>Tambah Integrasi Chat GPT</h3>
      </div>
      <br />
      <form v-on:submit.prevent="addChatGPT">
        <div class="row">
            <div class="col-md-12">
                <label>Nama Bot</label>
                <input type="text" class="form-control" v-model="form.name" autofocus required />
                <br />
                <label>AI Model</label>
                <input type="text" class="form-control" v-model="form.models" placeholder="Contoh: gpt-4o-mini" required />
                <small class="text-muted">
                    Isi dengan nama model yang valid, contoh: gpt-4o, gpt-4, claude-3-opus, dll.
                </small>
                <br>
                <label for="">API KEY</label>
                <textarea v-model="form.api_key" class="form-control"  rows="5"></textarea>
                <button
                  type="button"
                  class="btn btn-primary btn-sm mt-2 d-inline-flex align-items-center btn-block"
                  :disabled="testingKey"
                  @click="testApiKey">
                    <i v-if="testingKey" class="fas fa-spinner fa-spin mr-2"></i>
                    <i v-else class="fas fa-plug mr-2"></i>
                    <span v-if="testingKey">Testing...</span>
                    <span v-else>Test API Key</span>
                </button>
                <div v-if="testResult.message" class="card mt-2">
                    <div :class="['card-header', testResult.success ? 'bg-success text-white' : 'bg-danger text-white']">
                        {{ testResult.success ? 'API Key Valid' : 'API Key Error' }}
                    </div>
                    <div class="card-body">
                        <p class="mb-0">{{ testResult.message }}</p>
                    </div>
                </div>
            </div>
            <div class="col-md-6" style="margin-top:10px">
                <label>Max Token / Chat <b>Isi -1 untuk unlimited token</b></label>
                <input type="number" placeholder="contoh : 128" class="form-control" v-model="form.max_token_chat" autofocus required />
                <br />
                <label>Max Token / Nomor <b>Isi -1 untuk unlimited token</b></label>
                <input type="number" placeholder="contoh : 1024" class="form-control" v-model="form.daily_max_token_number" autofocus required />
                <br />
                <label>Max Token / Hari <b>Isi -1 untuk unlimited token</b></label>
                <input type="number" placeholder="contoh : 100000" class="form-control" v-model="form.daily_max_token_global" autofocus required />
                <br />
                <label>Temperature (0.1 - 1)</label>
                <input type="number" placeholder="0.5" min="0" max="1" step="0.1" class="form-control" v-model="form.temperature" autofocus required />
                <i>*Makin tinggi, jawaban makin bervariasi</i>
                <br>
                <br />
                <label>Top P (0.1 - 1)</label>
                <input type="number" placeholder="0.5" min="0" max="1" step="0.1" class="form-control" v-model="form.top_p" autofocus required />
                <i>*Makin tinggi, jawaban makin panjang</i>
                <br>
                <br />
                <label>Delay Balas Pesan (detik)</label>
                <input type="number" placeholder="0" min="0" class="form-control" v-model="form.reply_delay" autofocus />
                <i>*Waktu delay sebelum AI membalas pesan (dalam detik)</i>
            </div>
            <div class="col-md-6"  style="margin-top:10px">
                <label for="">Reenable Ai Duration (menit)</label>
                <input type="number" placeholder="" class="form-control" v-model="form.reenable_ai_duration" autofocus required />
                <i>*Waktu percakapan kembali di Respon AI, setelah user chat dengan cs asli / jika spam terdeteksi</i>
                <br>
                <label for="">Notif WhatsApp Admin saat AI Handover (Opsional)</label>
                <input type="text" placeholder="Contoh: 081234567890 atau 6281234567890" class="form-control" v-model="form.admin_notify_phone" />
                <i>*Nomor admin yang akan dapat WA notif saat AI handover ke CS manusia. Kosongkan = tidak dikirim notif.</i>
                <br>
                <input type="checkbox" id="disable-oot" class="checkbox" v-model="form.disable_oot" :true-value="1" :false-value="0">
                <label for="disable-oot">
                    <span class="checkbox-text" style="margin-left: 5px;">AI selalu coba respond <span class="badge badge-info">RECOMMENDED</span></span>
                </label>
                <br>
                <i>*Aktifkan supaya AI selalu mencoba menjawab walau pertanyaan tidak yakin nyambung. Default off (AI bisa silent kalau pertanyaan terlalu out-of-topic).</i>
                <hr>
                <div v-if="userRole === 'admin'" class="card thick-border" style="background:#fff8e1; border:2px dashed #ff9800; margin: 12px 0;">
                    <div class="card-body">
                        <h6 style="margin-top:0; color:#e65100;">🧾 INVOICE ADDON (KHUSUS BOT ADMIN)</h6>
                        <small class="form-text text-muted mb-2">
                            <i class="fas fa-info-circle"></i>
                            <b>Hanya aktifkan kalau bot ini melayani perpanjangan paket StarSender.</b>
                            User akan diminta email → bot otomatis generate invoice + PDF + kirim ke WA & email user.
                            Bukti transfer yang user kirim akan otomatis diforward ke nomor CS Admin di bawah.
                        </small>
                        <input type="checkbox" id="enable-invoice-addon" class="checkbox" v-model="form.enable_invoice_addon" :true-value="1" :false-value="0">
                        <label for="enable-invoice-addon">
                            <span class="checkbox-text" style="margin-left: 5px;">Aktifkan fitur Invoice Perpanjangan Paket</span>
                        </label>
                        <div v-if="form.enable_invoice_addon == 1">
                            <br>
                            <label>Nomor CS Admin Penerima Bukti Transfer</label>
                            <input type="text" v-model="form.cs_admin_phone" class="form-control" placeholder="Contoh: 6281319227392 (tanpa +)" />
                            <i style="font-size: 12px; color: #888;">*Nomor WA admin yang akan otomatis dapat forward bukti transfer dari user beserta detail invoice.</i>
                        </div>
                    </div>
                </div>
                <br>
                <br>
                <!-- <input name="hide" class="checkbox" type="checkbox" id="check-1" v-model="form.disable_during_office_hour">
                <label for="check-1">
                    <span class="checkbox-text" style="margin-left: 5px;">Disable During Office Hour</span>
                </label>
                <br> -->
                <input name="hide" class="checkbox" type="checkbox" id="check-2" v-model="form.enable_memory">
                <label for="check-2">
                    <span class="checkbox-text" style="margin-left: 5px;">Enable Memory</span>
                </label>
                <br>
                <i>*ChatGPT akan mengingat percakapan 24 jam terakhir (billing lebih mahal)</i>
                <br>
            </div>
        </div>
        <br>
        <div class="button-group d-flex pt-25">
            <button type="submit" class="btn btn-primary btn-block btn-default btn-squared text-capitalize mx-auto d-block">
              Tambah
            </button>
        </div>
      </form>
    </div>
  </template>
  
  <script>

  export default {
    props: ['device'],
    components: {
        },
    data() {
      return {
        form: {
            device: [],
            name: "",
            api_key: "",
            models: "gpt-4o-mini",
            enable_memory: true,
            max_token_chat: -1,
            daily_max_token_number: -1,
            daily_max_token_global: -1,
            temperature: 0.5,
            top_p: 0.5,
            disable_during_office_hour: false,
            fallback_message: "",
            reenable_ai_duration: 5,
            reply_delay: 0,
            custom_prompt: "",
        },
        testResult: {
            success: false,
            message: "",
        },
        testingKey: false,
      };
    },
    mounted() {
  
    },
    computed: {
            userRole() { return localStorage.getItem('role') || '' },
        },
        methods: {
      async addChatGPT(){
        try{
            let request = this.form
            console.log(request)
            //   request.multidevice = parseInt(request.multidevice)
            request.device_id = request.device.id
            request.enable_memory = request.enable_memory ? 1 : 0
            request.disable_during_office_hour = request.disable_during_office_hour ? 1 : 0
            request.max_token_chat = parseInt(request.max_token_chat)
            request.daily_max_token_number = parseInt(request.daily_max_token_number)
            request.daily_max_token_global = parseInt(request.daily_max_token_global)
            request.reenable_ai_duration = parseInt(request.reenable_ai_duration)
            request.reply_delay = parseInt(request.reply_delay) || 0
            request.temperature = parseFloat(request.temperature)
            request.top_p = parseFloat(request.top_p)
            request.type = 1
            let response = await this.$store.dispatch('chatgpt_create', request)
            
            this.$toast.success(response.data.message);
            this.$root.$emit("toggle_modal", "new_bot")
            this.$root.$emit("refresh_table", true)
        }catch(err){
          this.$toast.error(err.response.data.message);
        }
      },
      async testApiKey(){
        if(!this.form.api_key){
            this.$toast.error("Isi API Key terlebih dahulu");
            return;
        }
        this.testingKey = true;
        this.testResult = { success: false, message: "" };
        try{
            const payload = { api_key: this.form.api_key, models: this.form.models };
            const res = await this.$store.dispatch("chatgpt_test_key", payload);
            this.$toast.success(res.data.message);
            this.testResult = { success: true, message: res.data.message || 'API Key valid' };
        }catch(err){
            const msg = err.response?.data?.message || "Gagal mengetes API Key";
            this.$toast.error(msg);
            this.testResult = { success: false, message: msg };
        }finally{
            this.testingKey = false;
        }
      }
    },
  };
  </script>
  
